import React, { useEffect, useState } from 'react';
import { BellFilled, LoadingOutlined, DownOutlined, SettingOutlined } from '@ant-design/icons';
import { Layout, Button, Dropdown, Space, Badge, Row, Col, Spin, List, Image, Empty, Modal, Checkbox } from 'antd';
import { useUser } from '../../contexts/UserContext';
import LoginForm from '../user/LoginForm';
import { useTranslation } from 'react-i18next';
import DownloadList from '../download/DownloadList';
import { IS_GLOBAL } from '../../config';

import { useDispatch, useSelector } from "react-redux";
import { setFreeCheckbox } from "../../redux/slices/freeCheckboxSlice";
import { FETCH_PRODUCT_LIST } from "../../redux/actions";
import { setIsLogin } from '../../redux/slices/isLoginSlice';
import { setIsLoginModalOpen } from '../../redux/slices/isLoginModalOpenSlice';
import SignupForm from '../login/SignInForm';
import SigninForm from '../login/SignInForm';
import UserLoginForm from '../login/UserLoginForm';
import { setSignUp } from '../../redux/slices/signUpSlice';
import Profile from '../login/Profile';
import { useLocation } from 'react-router-dom';
const { Header } = Layout;

const languageItems = [
    {
        label: 'EN',
        key: "0",
    },
    !IS_GLOBAL && {
        label: 'FA',
        key: "1",
    },
    {
        label: 'AR',
        key: "2",
    },
    {
        label: 'TR',
        key: "3",
    },
];



const MasterHeader = () => {
    const { userLoading, notifications, notificationLoading, userChangeConfig, userConfigs } = useUser();
    //isLogin , setIsLoginModalOpen and isLoginModalOpen for useUser
    const [] = useState(false);
    const { t } = useTranslation();


    const location = useLocation();
    let curruntPage = location.pathname
    let curruntPageFlag = curruntPage === '/show-single-collection'

    const dispatch = useDispatch();
    const state = useSelector((state) => state);
    const freeCheckbox = state?.freeCheckbox;
    const isLogin = state?.initialize?.isAuthenticated;
    const isLoginModalOpen = state.isLoginModalOpen.isLoginModalOpen



    const showLoginModal = () => {
        dispatch(setIsLoginModalOpen(true));
    };

    const handleOkModal = () => {
        dispatch(setIsLoginModalOpen(false));
    };

    const handleCancelModal = () => {
        dispatch(setIsLoginModalOpen(false));
        dispatch(setSignUp(false))
    };

    const languageMenuProps = {
        items: languageItems,
        onClick: (e) => userChangeConfig("locale", languageItems[e.key].label.toLowerCase()),

    };

    const onChange = (e) => {
        dispatch(setFreeCheckbox(e.target.checked));
        dispatch({ type: FETCH_PRODUCT_LIST });
    };

    useEffect(() => {
        localStorage.setItem('lang', userConfigs.locale.locale)
    }, [userConfigs.locale])

    return (
        <Header className='main-header'>
            <div className='main-header-innrer'>
                <div className='head-left'>
                    <div className="logo"></div>
                    <div className='plugin-title'>
                        <div>CG TOOLS</div>
                        <div>PLUGIN</div>
                    </div>
                </div>
                <Row justify="space-between" style={{ width: "100%" }}>
                    <Col>
                        <Space>
                            <Button
                                type="text"
                                className='collapse-menu'
                                icon={userConfigs.collapsed ? <span className='svg-icon icon-menu' /> : <span className='svg-icon icon-menu' />}
                                onClick={() => userChangeConfig("collapsed", !userConfigs.collapsed)}
                            />
                            <Dropdown menu={languageMenuProps}>
                                <Button shape="round" >
                                    <Space>
                                        {userConfigs.localeName}
                                        <DownOutlined />
                                    </Space>
                                </Button>
                            </Dropdown>
                            {
                                !curruntPageFlag &&
                                <div style={{ marginLeft: '16px' }}>
                                    <Checkbox checked={freeCheckbox} onChange={onChange}>
                                        {t('user.free')}
                                    </Checkbox>
                                </div>
                            }

                        </Space>
                    </Col>
                    <Col>
                        <Space>
                            <div className='downloadBoxHeader'>
                                <DownloadList />
                            </div>
                            <Button shape="circle" className='dark-light-btn'
                                icon={<span className={'svg-icon icon-moon' + (userConfigs.dark ? '' : '-dark')} />}
                                onClick={() => userChangeConfig("dark", !userConfigs.dark)}
                                size="default" />



                            {false &&
                                <Dropdown
                                    menu={{
                                        items: notificationLoading ? [{
                                            key: "0",
                                            label: (<Space><Spin
                                                indicator={
                                                    <LoadingOutlined
                                                        style={{
                                                            fontSize: 24,
                                                        }}
                                                        spin
                                                    />
                                                }
                                            /></Space>)
                                        }] : notifications.length ? notifications.map((item, index) => {
                                            return {
                                                key: index,
                                                label: (
                                                    <List
                                                        itemLayout="horizontal" className='notification-items'>
                                                        <List.Item>
                                                            <List.Item.Meta
                                                                avatar={item.image != null ? <Image preview={false} src={item.image} /> : <span className='line'></span>}
                                                                title={<a href={item.link} target='_blank' rel="noreferrer">{item.title}</a>}
                                                                description={item.text}
                                                            />
                                                        </List.Item>
                                                    </List>
                                                ),
                                            };
                                        }) : [
                                            {
                                                key: "empty",
                                                label: (<Empty />)
                                            }
                                        ],
                                    }}
                                    placement="bottom"
                                    arrow={{
                                        pointAtCenter: true,
                                    }}
                                    overlayClassName='notifications'

                                >
                                    <Badge offset={[0, 10]} dot={true}>
                                        <Button shape="circle" icon={<BellFilled />} size="default" />
                                    </Badge>
                                </Dropdown>

                            }



                            {isLogin ? (
                                <Profile />
                            ) : (
                                <>
                                    <Button size='middle' className='user-btn' onClick={showLoginModal}>
                                        <span className='profileTextHeader'>
                                            {t('user.login')}
                                        </span>
                                        <span className='btn-icon svg-icon icon-user2' />
                                    </Button>
                                    <Modal
                                        open={isLoginModalOpen}
                                        onOk={handleOkModal}
                                        onCancel={handleCancelModal}
                                        footer={null}
                                        className=''
                                        style={{ padding: '0px' }}
                                    >
                                        <UserLoginForm />
                                    </Modal>
                                </>
                            )}
                        </Space>
                    </Col>
                </Row>
            </div>


        </Header>
    );
};

export default MasterHeader;
